import { BACKEND } from "../variables.js";
import axios from "axios";

const VERIFY_TENANTS_URL = BACKEND + "/verify/tenants";
const VERIFY_ROOMS_URL = BACKEND + "/verify/rooms";
const VERIFY_SUBSCRIPTIONS_URL = BACKEND + "/verify/subscriptions";
const VERIFY_BILLS_URL = BACKEND + "/verify/bills";

// payload.data carries { ids: [...] } or { id: "..." } and optionally { verified: false }
// to send a record back for review.
function post(url, payload) {
  return axios({
    method: "POST",
    url,
    data: payload.data,
    headers: { Authorization: payload.token },
  });
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["VERIFY_TENANTS"](state, payload) {
      return post(VERIFY_TENANTS_URL, payload);
    },
    ["VERIFY_ROOMS"](state, payload) {
      return post(VERIFY_ROOMS_URL, payload);
    },
    ["VERIFY_SUBSCRIPTIONS"](state, payload) {
      return post(VERIFY_SUBSCRIPTIONS_URL, payload);
    },
    ["VERIFY_BILLS"](state, payload) {
      return post(VERIFY_BILLS_URL, payload);
    },
  },
};
